export const javascriptQuizData = [
    {
        module: "Day 1 – Introduction to JavaScript",
        questions: [
            {
                id: "js-1-1",
                question: "What is JavaScript primarily used for?",
                options: [
                    "Styling web pages",
                    "Making web pages interactive and dynamic",
                    "Structuring HTML documents",
                    "Managing databases",
                ],
                answer: "Making web pages interactive and dynamic",
            },
            {
                id: "js-1-2",
                question: "Where can JavaScript code run?",
                options: [
                    "Only in the browser",
                    "Only on the server",
                    "In the browser and on the server with Node.js",
                    "Only in mobile apps",
                ],
                answer: "In the browser and on the server with Node.js",
            },
            {
                id: "js-1-3",
                question: "Which HTML tag is used to embed JavaScript in a webpage?",
                options: ["<js>", "<javascript>", "<script>", "<code>"],
                answer: "<script>",
            },
            {
                id: "js-1-4",
                question: "What does the console.log() function do?",
                options: [
                    "Saves data to a file",
                    "Prints output to the browser's developer console",
                    "Displays an alert box",
                    "Creates a new HTML element",
                ],
                answer: "Prints output to the browser's developer console",
            },
            {
                id: "js-1-5",
                question: "JavaScript is a ______ language.",
                options: [
                    "compiled, statically typed",
                    "interpreted, dynamically typed",
                    "assembly-based",
                    "binary-only",
                ],
                answer: "interpreted, dynamically typed",
            },
            {
                id: "js-1-6",
                question: "Which company created JavaScript?",
                options: ["Google", "Microsoft", "Apple", "Netscape"],
                answer: "Netscape",
            },
            {
                id: "js-1-7",
                question: "What year was JavaScript created?",
                options: ["1990", "1995", "2000", "2005"],
                answer: "1995",
            },
            {
                id: "js-1-8",
                question: "What is the correct way to write a single-line comment in JavaScript?",
                options: ["# This is a comment", "<!-- comment -->", "// This is a comment", "/* comment"],
                answer: "// This is a comment",
            },
            {
                id: "js-1-9",
                question: "Which of these is a valid way to display a message to the user?",
                options: ["message.show()", "alert('Hello')", "display('Hello')", "print('Hello')"],
                answer: "alert('Hello')",
            },
            {
                id: "js-1-10",
                question: "What extension do JavaScript files use?",
                options: [".java", ".jsc", ".js", ".jsx"],
                answer: ".js",
            },
            {
                id: "js-1-11",
                question: "What is ECMAScript?",
                options: [
                    "A JavaScript framework",
                    "The official specification standard that JavaScript follows",
                    "A browser-only API",
                    "A type of database",
                ],
                answer: "The official specification standard that JavaScript follows",
            },
            {
                id: "js-1-12",
                question: "Which symbol ends a statement in JavaScript?",
                options: [":", ".", ";", ","],
                answer: ";",
            },
            {
                id: "js-1-13",
                question: "What does it mean that JavaScript is 'dynamically typed'?",
                options: [
                    "Variables must be declared with their type",
                    "Variables get their type automatically at runtime",
                    "The language runs faster than other languages",
                    "Code is validated before running",
                ],
                answer: "Variables get their type automatically at runtime",
            },
            {
                id: "js-1-14",
                question: "What does 'console' refer to in console.log()?",
                options: [
                    "A hardware device",
                    "A JavaScript object representing the browser's developer tools console",
                    "A Python library",
                    "An HTML element",
                ],
                answer: "A JavaScript object representing the browser's developer tools console",
            },
            {
                id: "js-1-15",
                question: "Which of the following is NOT a JavaScript data type?",
                options: ["string", "boolean", "character", "number"],
                answer: "character",
            },
        ],
    },
    {
        module: "Day 2 – Variables, Data Types & Operators",
        questions: [
            {
                id: "js-2-1",
                question: "Which keyword declares a block-scoped variable that can be reassigned?",
                options: ["var", "let", "const", "def"],
                answer: "let",
            },
            {
                id: "js-2-2",
                question: "Which keyword declares a variable that CANNOT be reassigned?",
                options: ["let", "var", "const", "static"],
                answer: "const",
            },
            {
                id: "js-2-3",
                question: "What is the result of: typeof 42?",
                options: ["'int'", "'number'", "'float'", "'integer'"],
                answer: "'number'",
            },
            {
                id: "js-2-4",
                question: "What is the result of: typeof 'hello'?",
                options: ["'text'", "'char'", "'string'", "'word'"],
                answer: "'string'",
            },
            {
                id: "js-2-5",
                question: "What does === (triple equals) check in JavaScript?",
                options: [
                    "Value only",
                    "Type only",
                    "Both value and type",
                    "Reference equality",
                ],
                answer: "Both value and type",
            },
            {
                id: "js-2-6",
                question: "What is the output of: console.log(5 + '3')?",
                options: ["8", "'53'", "53", "Error"],
                answer: "'53'",
            },
            {
                id: "js-2-7",
                question: "Which of these is a falsy value in JavaScript?",
                options: ["'false'", "1", "[]", "0"],
                answer: "0",
            },
            {
                id: "js-2-8",
                question: "What is the difference between null and undefined in JavaScript?",
                options: [
                    "They are the same",
                    "null means intentionally empty; undefined means a variable was declared but not assigned",
                    "undefined means intentionally empty; null means not declared",
                    "Both mean a variable has no value",
                ],
                answer: "null means intentionally empty; undefined means a variable was declared but not assigned",
            },
            {
                id: "js-2-9",
                question: "What is the result of: 10 % 3?",
                options: ["3", "1", "0", "10"],
                answer: "1",
            },
            {
                id: "js-2-10",
                question: "Which operator is used for exponentiation (raising to a power)?",
                options: ["^", "**", "^^", "pow()"],
                answer: "**",
            },
            {
                id: "js-2-11",
                question: "What is the result of: Boolean('')?",
                options: ["true", "false", "undefined", "Error"],
                answer: "false",
            },
            {
                id: "js-2-12",
                question: "What does NaN stand for?",
                options: ["Not a Node", "Not a Number", "Null and Null", "New and Named"],
                answer: "Not a Number",
            },
            {
                id: "js-2-13",
                question: "Which keyword should you prefer for most modern variable declarations?",
                options: ["var", "let and const", "define", "assign"],
                answer: "let and const",
            },
            {
                id: "js-2-14",
                question: "What is the result of: console.log(2 ** 3)?",
                options: ["6", "5", "8", "9"],
                answer: "8",
            },
            {
                id: "js-2-15",
                question: "A variable declared with var inside a function is accessible:",
                options: [
                    "Only inside the block it was declared in",
                    "Throughout the entire function",
                    "Globally in all files",
                    "Only on the next line",
                ],
                answer: "Throughout the entire function",
            },
        ],
    },
    {
        module: "Day 3 – Functions & Scope",
        questions: [
            {
                id: "js-3-1",
                question: "Which of the following is a valid function declaration?",
                options: [
                    "function = greet() {}",
                    "function greet() {}",
                    "greet function() {}",
                    "def greet() {}",
                ],
                answer: "function greet() {}",
            },
            {
                id: "js-3-2",
                question: "What is an arrow function?",
                options: [
                    "A function that runs backwards",
                    "A shorthand syntax for writing functions using =>",
                    "A function that only works in loops",
                    "A function with no return value",
                ],
                answer: "A shorthand syntax for writing functions using =>",
            },
            {
                id: "js-3-3",
                question: "What does this arrow function return?\n\nconst add = (a, b) => a + b;",
                options: ["Nothing", "The string 'a + b'", "The sum of a and b", "undefined"],
                answer: "The sum of a and b",
            },
            {
                id: "js-3-4",
                question: "What is a 'first-class function' in JavaScript?",
                options: [
                    "A function that runs first",
                    "A function that is treated as a value and can be passed around",
                    "A function defined at the top of the file",
                    "A function with no parameters",
                ],
                answer: "A function that is treated as a value and can be passed around",
            },
            {
                id: "js-3-5",
                question: "What does 'hoisting' mean for function declarations?",
                options: [
                    "Functions are moved to the end of the file",
                    "Function declarations are moved to the top of their scope before execution",
                    "Functions can only be used after they are declared",
                    "Functions cannot be reassigned",
                ],
                answer: "Function declarations are moved to the top of their scope before execution",
            },
            {
                id: "js-3-6",
                question: "What is a default parameter?",
                options: [
                    "A parameter that is always required",
                    "A fallback value used when no argument is provided",
                    "A parameter declared with const",
                    "The first parameter of every function",
                ],
                answer: "A fallback value used when no argument is provided",
            },
            {
                id: "js-3-7",
                question: `What will this code output?\n\nconst greet = name => \`Hello, \${name}!\`;\nconsole.log(greet('Riya'));`,
                options: ["Hello, name!", "Hello, Riya!", "undefined", "Error"],
                answer: "Hello, Riya!",
            },
            {
                id: "js-3-8",
                question: "What is a closure?",
                options: [
                    "A function that has no return value",
                    "A function that remembers the variables from its outer scope",
                    "A function that closes the browser",
                    "A function that can only be called once",
                ],
                answer: "A function that remembers the variables from its outer scope",
            },
            {
                id: "js-3-9",
                question: "What is the scope of a variable declared with let inside an if block?",
                options: [
                    "Global scope",
                    "Function scope",
                    "Block scope (only inside the if block)",
                    "Module scope",
                ],
                answer: "Block scope (only inside the if block)",
            },
            {
                id: "js-3-10",
                question: "What is a callback function?",
                options: [
                    "A function that calls itself",
                    "A function passed as an argument to another function",
                    "A function that always returns true",
                    "A function defined inside a class",
                ],
                answer: "A function passed as an argument to another function",
            },
            {
                id: "js-3-11",
                question: "What is the rest parameter (...args) used for?",
                options: [
                    "To spread an array into individual arguments",
                    "To collect multiple arguments into a single array",
                    "To declare optional parameters",
                    "To pause execution",
                ],
                answer: "To collect multiple arguments into a single array",
            },
            {
                id: "js-3-12",
                question: "What is a pure function?",
                options: [
                    "A function with no parameters",
                    "A function that always returns the same output for the same input and has no side effects",
                    "A function declared with const",
                    "A function that calls the DOM",
                ],
                answer: "A function that always returns the same output for the same input and has no side effects",
            },
            {
                id: "js-3-13",
                question: "How do you call a function named calculate?",
                options: ["call calculate()", "run calculate()", "calculate()", "execute calculate"],
                answer: "calculate()",
            },
            {
                id: "js-3-14",
                question: "What is an immediately invoked function expression (IIFE)?",
                options: [
                    "A function that only runs inside a loop",
                    "A function that runs immediately when it is defined",
                    "A function declared after it is used",
                    "A function with no name",
                ],
                answer: "A function that runs immediately when it is defined",
            },
            {
                id: "js-3-15",
                question: "What does the return keyword do inside a function?",
                options: [
                    "Stops the loop",
                    "Sends a value back to the caller and exits the function",
                    "Skips to the next iteration",
                    "Declares a local variable",
                ],
                answer: "Sends a value back to the caller and exits the function",
            },
        ],
    },
    {
        module: "Day 4 – Objects & Arrays",
        questions: [
            {
                id: "js-4-1",
                question: "How do you create an object in JavaScript?",
                options: [
                    "let obj = [];",
                    "let obj = {};",
                    "let obj = Object;",
                    "let obj = new Array();",
                ],
                answer: "let obj = {};",
            },
            {
                id: "js-4-2",
                question: "How do you access the name property of an object called person?",
                options: [
                    "person->name",
                    "person[name]",
                    "person.name",
                    "person::name",
                ],
                answer: "person.name",
            },
            {
                id: "js-4-3",
                question: "Which array method adds an element to the END of an array?",
                options: ["push()", "pop()", "shift()", "unshift()"],
                answer: "push()",
            },
            {
                id: "js-4-4",
                question: "Which array method removes the LAST element of an array?",
                options: ["push()", "pop()", "shift()", "unshift()"],
                answer: "pop()",
            },
            {
                id: "js-4-5",
                question: "What does the .map() method do?",
                options: [
                    "Removes elements that don't match a condition",
                    "Creates a new array by transforming each element",
                    "Finds the first matching element",
                    "Combines all elements into one value",
                ],
                answer: "Creates a new array by transforming each element",
            },
            {
                id: "js-4-6",
                question: "What does the .filter() method return?",
                options: [
                    "The first element that matches",
                    "A new array with elements that pass the test",
                    "True or false",
                    "The index of the matching element",
                ],
                answer: "A new array with elements that pass the test",
            },
            {
                id: "js-4-7",
                question: "What is destructuring in JavaScript?",
                options: [
                    "Deleting properties from an object",
                    "Unpacking values from arrays or objects into separate variables",
                    "Looping through an array",
                    "Combining two objects",
                ],
                answer: "Unpacking values from arrays or objects into separate variables",
            },
            {
                id: "js-4-8",
                question: "What is the spread operator (...) used for with arrays?",
                options: [
                    "To collect all remaining elements",
                    "To expand an array into individual elements",
                    "To freeze an array",
                    "To sort an array",
                ],
                answer: "To expand an array into individual elements",
            },
            {
                id: "js-4-9",
                question: "What does arr.find() return?",
                options: [
                    "The index of the first matching element",
                    "The first element that satisfies the condition",
                    "All matching elements",
                    "true or false",
                ],
                answer: "The first element that satisfies the condition",
            },
            {
                id: "js-4-10",
                question: "What does arr.reduce() do?",
                options: [
                    "Reduces the number of elements in an array",
                    "Accumulates all elements into a single value",
                    "Removes duplicate elements",
                    "Reverses the array",
                ],
                answer: "Accumulates all elements into a single value",
            },
            {
                id: "js-4-11",
                question: "How do you check if a property exists in an object?",
                options: [
                    "obj.hasOwnProperty('key')",
                    "obj.includes('key')",
                    "obj.find('key')",
                    "obj.exists('key')",
                ],
                answer: "obj.hasOwnProperty('key')",
            },
            {
                id: "js-4-12",
                question: "What does Object.keys(obj) return?",
                options: [
                    "An array of the object's values",
                    "An array of the object's property names",
                    "The number of properties",
                    "A new copy of the object",
                ],
                answer: "An array of the object's property names",
            },
            {
                id: "js-4-13",
                question: "How do you get the length of an array?",
                options: ["arr.size()", "arr.count", "arr.length", "arr.len()"],
                answer: "arr.length",
            },
            {
                id: "js-4-14",
                question: "What does arr.includes(3) return if 3 is not in the array?",
                options: ["0", "null", "false", "undefined"],
                answer: "false",
            },
            {
                id: "js-4-15",
                question: "What is a shorthand property in an object literal?",
                options: [
                    "{ name: name } when variable and key have same name, shortened to { name }",
                    "A property that cannot be changed",
                    "A function defined inside an object",
                    "A property accessed with bracket notation",
                ],
                answer: "{ name: name } when variable and key have same name, shortened to { name }",
            },
        ],
    },
    {
        module: "Day 5 – Control Flow: If, Loops & Switch",
        questions: [
            {
                id: "js-5-1",
                question: "What does the ternary operator look like in JavaScript?",
                options: [
                    "condition ? value_if_true : value_if_false",
                    "condition ?? value_if_true : value_if_false",
                    "if (condition) value_if_true else value_if_false",
                    "condition -> value_if_true | value_if_false",
                ],
                answer: "condition ? value_if_true : value_if_false",
            },
            {
                id: "js-5-2",
                question: "What will this code print?\n\nfor (let i = 0; i < 3; i++) { console.log(i); }",
                options: ["1 2 3", "0 1 2", "0 1 2 3", "1 2"],
                answer: "0 1 2",
            },
            {
                id: "js-5-3",
                question: "Which loop checks its condition AFTER running its body at least once?",
                options: ["for loop", "while loop", "do...while loop", "for...of loop"],
                answer: "do...while loop",
            },
            {
                id: "js-5-4",
                question: "What does the break keyword do inside a loop?",
                options: [
                    "Skips to the next iteration",
                    "Exits the loop completely",
                    "Restarts the loop",
                    "Pauses execution for 1 second",
                ],
                answer: "Exits the loop completely",
            },
            {
                id: "js-5-5",
                question: "What does the continue keyword do inside a loop?",
                options: [
                    "Exits the loop",
                    "Skips the current iteration and continues with the next one",
                    "Restarts the loop from the beginning",
                    "Pauses the loop",
                ],
                answer: "Skips the current iteration and continues with the next one",
            },
            {
                id: "js-5-6",
                question: "What is the for...of loop used for?",
                options: [
                    "Iterating over object properties",
                    "Iterating over iterable values like arrays and strings",
                    "Running code a fixed number of times",
                    "Checking conditions repeatedly",
                ],
                answer: "Iterating over iterable values like arrays and strings",
            },
            {
                id: "js-5-7",
                question: "What is the for...in loop used for?",
                options: [
                    "Iterating over array elements",
                    "Iterating over the keys/properties of an object",
                    "Counting iterations",
                    "Looping over strings",
                ],
                answer: "Iterating over the keys/properties of an object",
            },
            {
                id: "js-5-8",
                question: "What does the ?? (nullish coalescing) operator do?",
                options: [
                    "Returns the right side if left side is null or undefined",
                    "Returns the left side if it is truthy",
                    "Compares two values strictly",
                    "Ternary shorthand",
                ],
                answer: "Returns the right side if left side is null or undefined",
            },
            {
                id: "js-5-9",
                question: "What does switch(x) do if no case matches and there is no default?",
                options: [
                    "Throws an error",
                    "Runs all cases",
                    "Does nothing and exits the switch",
                    "Runs the first case",
                ],
                answer: "Does nothing and exits the switch",
            },
            {
                id: "js-5-10",
                question: "What happens if you forget to add break in a switch case?",
                options: [
                    "Only the matched case runs",
                    "An error is thrown",
                    "Fall-through occurs and subsequent cases also run",
                    "The switch exits immediately",
                ],
                answer: "Fall-through occurs and subsequent cases also run",
            },
            {
                id: "js-5-11",
                question: "What is short-circuit evaluation with &&?",
                options: [
                    "Returns the first truthy value",
                    "Returns the second value if the first is truthy, otherwise returns the first",
                    "Both values must be true for any value to be returned",
                    "Returns true or false always",
                ],
                answer: "Returns the second value if the first is truthy, otherwise returns the first",
            },
            {
                id: "js-5-12",
                question: "What will: console.log('' || 'default') output?",
                options: ["''", "'default'", "undefined", "Error"],
                answer: "'default'",
            },
            {
                id: "js-5-13",
                question: "What is the optional chaining operator (?.) used for?",
                options: [
                    "Declaring optional function parameters",
                    "Safely accessing nested object properties without throwing an error if they are undefined",
                    "Checking if two values are equal",
                    "Creating optional loops",
                ],
                answer: "Safely accessing nested object properties without throwing an error if they are undefined",
            },
            {
                id: "js-5-14",
                question: "What will: console.log(true && false || true) output?",
                options: ["false", "true", "undefined", "Error"],
                answer: "true",
            },
            {
                id: "js-5-15",
                question: "Which is the correct way to write an if-else statement?",
                options: [
                    "if x > 5 { } else { }",
                    "if (x > 5) { } else { }",
                    "if [x > 5] { } else { }",
                    "if x > 5 then { } else { }",
                ],
                answer: "if (x > 5) { } else { }",
            },
        ],
    },
    {
        module: "Day 6 – DOM Manipulation",
        questions: [
            {
                id: "js-6-1",
                question: "What does DOM stand for?",
                options: [
                    "Document Object Method",
                    "Document Object Model",
                    "Data Object Management",
                    "Dynamic Object Mapping",
                ],
                answer: "Document Object Model",
            },
            {
                id: "js-6-2",
                question: "Which method selects the FIRST element matching a CSS selector?",
                options: [
                    "document.getElementById()",
                    "document.querySelector()",
                    "document.getElement()",
                    "document.selectAll()",
                ],
                answer: "document.querySelector()",
            },
            {
                id: "js-6-3",
                question: "Which property changes the text content of an element?",
                options: ["element.innerHTML", "element.textContent", "element.value", "element.text"],
                answer: "element.textContent",
            },
            {
                id: "js-6-4",
                question: "What is the difference between textContent and innerHTML?",
                options: [
                    "They are identical",
                    "textContent treats content as plain text; innerHTML treats it as HTML markup",
                    "innerHTML is safer for user input",
                    "textContent can set HTML elements",
                ],
                answer: "textContent treats content as plain text; innerHTML treats it as HTML markup",
            },
            {
                id: "js-6-5",
                question: "Which method creates a new HTML element?",
                options: [
                    "document.newElement('div')",
                    "document.createElement('div')",
                    "document.addElement('div')",
                    "document.makeElement('div')",
                ],
                answer: "document.createElement('div')",
            },
            {
                id: "js-6-6",
                question: "Which method adds a child element to the end of a parent?",
                options: ["appendChild()", "addChild()", "insertChild()", "prependChild()"],
                answer: "appendChild()",
            },
            {
                id: "js-6-7",
                question: "How do you add a CSS class to an element using JavaScript?",
                options: [
                    "element.class = 'active'",
                    "element.classList.add('active')",
                    "element.addClass('active')",
                    "element.style.class = 'active'",
                ],
                answer: "element.classList.add('active')",
            },
            {
                id: "js-6-8",
                question: "How do you change the background colour of an element using JavaScript?",
                options: [
                    "element.css('background', 'blue')",
                    "element.style.backgroundColor = 'blue'",
                    "element.background = 'blue'",
                    "element.setStyle('background-color', 'blue')",
                ],
                answer: "element.style.backgroundColor = 'blue'",
            },
            {
                id: "js-6-9",
                question: "Which method removes an element from the DOM?",
                options: ["element.hide()", "element.delete()", "element.remove()", "element.destroy()"],
                answer: "element.remove()",
            },
            {
                id: "js-6-10",
                question: "What does document.querySelectorAll() return?",
                options: [
                    "The first matching element",
                    "A NodeList of all matching elements",
                    "An HTML array",
                    "The parent of matching elements",
                ],
                answer: "A NodeList of all matching elements",
            },
            {
                id: "js-6-11",
                question: "How do you get the value from an input field?",
                options: [
                    "inputElement.textContent",
                    "inputElement.innerText",
                    "inputElement.value",
                    "inputElement.content",
                ],
                answer: "inputElement.value",
            },
            {
                id: "js-6-12",
                question: "What does element.setAttribute('id', 'main') do?",
                options: [
                    "Reads the id attribute value",
                    "Removes the id attribute",
                    "Sets the element's id attribute to 'main'",
                    "Creates a new element with id 'main'",
                ],
                answer: "Sets the element's id attribute to 'main'",
            },
            {
                id: "js-6-13",
                question: "What is the parent of all HTML elements in the DOM?",
                options: ["window", "document", "body", "html"],
                answer: "document",
            },
            {
                id: "js-6-14",
                question: "What does element.classList.toggle('hidden') do?",
                options: [
                    "Always adds the class",
                    "Always removes the class",
                    "Adds the class if absent, removes it if present",
                    "Hides the element permanently",
                ],
                answer: "Adds the class if absent, removes it if present",
            },
            {
                id: "js-6-15",
                question: "Which property gives you the direct HTML content inside an element?",
                options: ["element.value", "element.textContent", "element.innerHTML", "element.content"],
                answer: "element.innerHTML",
            },
        ],
    },
    {
        module: "Day 7 – Events & Event Listeners",
        questions: [
            {
                id: "js-7-1",
                question: "Which method attaches an event listener to an element?",
                options: ["element.on()", "element.listen()", "element.addEventListener()", "element.attachEvent()"],
                answer: "element.addEventListener()",
            },
            {
                id: "js-7-2",
                question: "What is the 'event' object passed to an event handler?",
                options: [
                    "A string describing the action",
                    "An object with details about what happened (type, target, etc.)",
                    "The HTML element that fired the event",
                    "The function that handled the event",
                ],
                answer: "An object with details about what happened (type, target, etc.)",
            },
            {
                id: "js-7-3",
                question: "What does event.preventDefault() do?",
                options: [
                    "Stops the event from propagating",
                    "Prevents the browser's default behaviour for the event",
                    "Removes the event listener",
                    "Delays the event",
                ],
                answer: "Prevents the browser's default behaviour for the event",
            },
            {
                id: "js-7-4",
                question: "What is event bubbling?",
                options: [
                    "Events that run in a loop",
                    "When an event fires on a child element and then propagates up to parent elements",
                    "Multiple events firing at once",
                    "Events that cancel themselves",
                ],
                answer: "When an event fires on a child element and then propagates up to parent elements",
            },
            {
                id: "js-7-5",
                question: "What does event.stopPropagation() do?",
                options: [
                    "Prevents the event's default action",
                    "Stops the event from bubbling up to parent elements",
                    "Removes all event listeners",
                    "Stops the code from running",
                ],
                answer: "Stops the event from bubbling up to parent elements",
            },
            {
                id: "js-7-6",
                question: "Which event fires when the user presses a key on the keyboard?",
                options: ["keypress", "keydown", "keyup", "All of the above"],
                answer: "All of the above",
            },
            {
                id: "js-7-7",
                question: "What event fires when a form is submitted?",
                options: ["click", "change", "submit", "input"],
                answer: "submit",
            },
            {
                id: "js-7-8",
                question: "What is event delegation?",
                options: [
                    "Assigning multiple handlers to one element",
                    "Attaching a single event listener to a parent to handle events from child elements",
                    "Removing an event from a child element",
                    "Delegating events to the server",
                ],
                answer: "Attaching a single event listener to a parent to handle events from child elements",
            },
            {
                id: "js-7-9",
                question: "What does event.target refer to?",
                options: [
                    "The element the event listener is attached to",
                    "The element that actually triggered the event",
                    "The parent of the element",
                    "The event type",
                ],
                answer: "The element that actually triggered the event",
            },
            {
                id: "js-7-10",
                question: "Which event fires when the mouse enters an element?",
                options: ["mouseover", "mouseenter", "mouseenter and mouseover", "hover"],
                answer: "mouseenter and mouseover",
            },
            {
                id: "js-7-11",
                question: "Which event fires after all page resources (including images) are fully loaded?",
                options: ["DOMContentLoaded", "load", "ready", "start"],
                answer: "load",
            },
            {
                id: "js-7-12",
                question: "Which event fires when an input field value changes?",
                options: ["click", "change", "focus", "submit"],
                answer: "change",
            },
            {
                id: "js-7-13",
                question: "How do you remove an event listener?",
                options: [
                    "element.removeEvent('click', handler)",
                    "element.removeEventListener('click', handler)",
                    "element.detachEvent('click', handler)",
                    "element.clearEvent('click')",
                ],
                answer: "element.removeEventListener('click', handler)",
            },
            {
                id: "js-7-14",
                question: "What event fires when the user releases a mouse button?",
                options: ["click", "mousedown", "mouseup", "mouseleave"],
                answer: "mouseup",
            },
            {
                id: "js-7-15",
                question: "What type does event.key return?",
                options: ["number", "boolean", "string", "object"],
                answer: "string",
            },
        ],
    },
    {
        module: "Day 8 – Asynchronous JavaScript",
        questions: [
            {
                id: "js-8-1",
                question: "What is a Promise in JavaScript?",
                options: [
                    "A guarantee that code will never fail",
                    "An object representing the eventual result of an async operation",
                    "A synchronous function",
                    "A type of loop",
                ],
                answer: "An object representing the eventual result of an async operation",
            },
            {
                id: "js-8-2",
                question: "What are the three states of a Promise?",
                options: [
                    "start, running, done",
                    "pending, fulfilled, rejected",
                    "loading, success, error",
                    "created, executing, returned",
                ],
                answer: "pending, fulfilled, rejected",
            },
            {
                id: "js-8-3",
                question: "What does the async keyword do when put before a function?",
                options: [
                    "Makes the function run in parallel",
                    "Makes the function return a Promise automatically",
                    "Makes the function run faster",
                    "Declares a synchronous function",
                ],
                answer: "Makes the function return a Promise automatically",
            },
            {
                id: "js-8-4",
                question: "What does await do inside an async function?",
                options: [
                    "Pauses the entire JavaScript engine",
                    "Waits for a Promise to resolve before continuing",
                    "Creates a new thread",
                    "Loops until a condition is met",
                ],
                answer: "Waits for a Promise to resolve before continuing",
            },
            {
                id: "js-8-5",
                question: "What is the event loop responsible for?",
                options: [
                    "Running loops in JavaScript",
                    "Managing the call stack, Web APIs, and callback queue to handle async code",
                    "Executing promises synchronously",
                    "Loading CSS styles",
                ],
                answer: "Managing the call stack, Web APIs, and callback queue to handle async code",
            },
            {
                id: "js-8-6",
                question: "How do you handle a rejected Promise with async/await syntax?",
                options: [
                    "Using .catch()",
                    "Using try-catch block around the await",
                    "Using .finally()",
                    "Using if-else",
                ],
                answer: "Using try-catch block around the await",
            },
            {
                id: "js-8-7",
                question: "What does Promise.all([p1, p2]) do?",
                options: [
                    "Runs promises one after another",
                    "Runs all promises in parallel and resolves when ALL have resolved",
                    "Returns the first promise to resolve",
                    "Ignores rejected promises",
                ],
                answer: "Runs all promises in parallel and resolves when ALL have resolved",
            },
            {
                id: "js-8-8",
                question: "What is callback hell?",
                options: [
                    "A callback that throws an error",
                    "Deeply nested callbacks that make code hard to read and maintain",
                    "A callback called too many times",
                    "A callback that runs synchronously",
                ],
                answer: "Deeply nested callbacks that make code hard to read and maintain",
            },
            {
                id: "js-8-9",
                question: "Which method runs after a Promise settles, regardless of success or failure?",
                options: [".then()", ".catch()", ".finally()", ".always()"],
                answer: ".finally()",
            },
            {
                id: "js-8-10",
                question: "What does setTimeout(fn, 1000) do?",
                options: [
                    "Runs fn every 1000 milliseconds",
                    "Runs fn after a delay of 1000 milliseconds (1 second)",
                    "Pauses all code for 1 second",
                    "Runs fn before all synchronous code",
                ],
                answer: "Runs fn after a delay of 1000 milliseconds (1 second)",
            },
            {
                id: "js-8-11",
                question: "What does setInterval(fn, 500) do?",
                options: [
                    "Runs fn once after 500ms",
                    "Runs fn repeatedly every 500 milliseconds",
                    "Schedules fn 500 times",
                    "Pauses fn for 500ms",
                ],
                answer: "Runs fn repeatedly every 500 milliseconds",
            },
            {
                id: "js-8-12",
                question: "Which runs first?\n\nconsole.log('A');\nsetTimeout(() => console.log('B'), 0);\nconsole.log('C');",
                options: ["A B C", "B A C", "A C B", "C A B"],
                answer: "A C B",
            },
            {
                id: "js-8-13",
                question: "What does Promise.race([p1, p2]) do?",
                options: [
                    "Returns the slowest promise",
                    "Resolves or rejects as soon as the FIRST promise settles",
                    "Runs promises in order",
                    "Cancels all promises after one resolves",
                ],
                answer: "Resolves or rejects as soon as the FIRST promise settles",
            },
            {
                id: "js-8-14",
                question: "Is JavaScript single-threaded or multi-threaded?",
                options: [
                    "Multi-threaded",
                    "Single-threaded",
                    "Both depending on the context",
                    "Neither",
                ],
                answer: "Single-threaded",
            },
            {
                id: "js-8-15",
                question: "What keyword is used before a function to make it asynchronous?",
                options: ["await", "promise", "async", "defer"],
                answer: "async",
            },
        ],
    },
    {
        module: "Day 9 – Fetch API & Working with APIs",
        questions: [
            {
                id: "js-9-1",
                question: "What does the Fetch API do?",
                options: [
                    "Fetches data from a local database",
                    "Makes HTTP requests to external resources and returns a Promise",
                    "Refreshes the page",
                    "Uploads files to a server",
                ],
                answer: "Makes HTTP requests to external resources and returns a Promise",
            },
            {
                id: "js-9-2",
                question: "What does fetch() return?",
                options: ["The raw data", "A Promise that resolves to a Response object", "JSON directly", "undefined"],
                answer: "A Promise that resolves to a Response object",
            },
            {
                id: "js-9-3",
                question: "What does response.json() do after a fetch call?",
                options: [
                    "Converts the response to a string",
                    "Parses the response body as JSON and returns a Promise",
                    "Sends JSON to the server",
                    "Validates the JSON format",
                ],
                answer: "Parses the response body as JSON and returns a Promise",
            },
            {
                id: "js-9-4",
                question: "What does REST stand for?",
                options: [
                    "Remote Execution Simple Transfer",
                    "Representational State Transfer",
                    "Remote State Transfer",
                    "Resource Extensible State Type",
                ],
                answer: "Representational State Transfer",
            },
            {
                id: "js-9-5",
                question: "Which HTTP method is used to retrieve data from an API?",
                options: ["POST", "PUT", "GET", "DELETE"],
                answer: "GET",
            },
            {
                id: "js-9-6",
                question: "Which HTTP method is used to CREATE new data on a server?",
                options: ["GET", "POST", "PATCH", "DELETE"],
                answer: "POST",
            },
            {
                id: "js-9-7",
                question: "What does JSON.stringify() do?",
                options: [
                    "Parses a JSON string into a JavaScript object",
                    "Converts a JavaScript object into a JSON string",
                    "Validates a JSON string",
                    "Formats JSON for display",
                ],
                answer: "Converts a JavaScript object into a JSON string",
            },
            {
                id: "js-9-8",
                question: "What does JSON.parse() do?",
                options: [
                    "Converts a JavaScript object into a JSON string",
                    "Parses a JSON string into a JavaScript object",
                    "Validates JSON structure",
                    "Sends JSON to an API",
                ],
                answer: "Parses a JSON string into a JavaScript object",
            },
            {
                id: "js-9-9",
                question: "What does a 404 HTTP status code mean?",
                options: [
                    "Server error",
                    "Forbidden access",
                    "Resource not found",
                    "Successful request",
                ],
                answer: "Resource not found",
            },
            {
                id: "js-9-10",
                question: "What does a 200 HTTP status code mean?",
                options: ["Resource created", "Not found", "Success", "Redirect"],
                answer: "Success",
            },
            {
                id: "js-9-11",
                question: "What does CORS stand for?",
                options: [
                    "Cross-Origin Resource Sharing",
                    "Client-Origin Request Standard",
                    "Cross-Origin Request Security",
                    "Client-Only Resource Scheme",
                ],
                answer: "Cross-Origin Resource Sharing",
            },
            {
                id: "js-9-12",
                question: "Which header is typically required when sending JSON in a POST request?",
                options: [
                    "Content-Type: text/plain",
                    "Content-Type: application/json",
                    "Accept: application/json",
                    "Authorization: Bearer token",
                ],
                answer: "Content-Type: application/json",
            },
            {
                id: "js-9-13",
                question: "What does an API key do?",
                options: [
                    "Encrypts the response data",
                    "Authenticates and identifies the client making the API request",
                    "Changes the response format",
                    "Caches responses automatically",
                ],
                answer: "Authenticates and identifies the client making the API request",
            },
            {
                id: "js-9-14",
                question: "What happens in the .catch() block of a fetch call?",
                options: [
                    "It runs when the HTTP status is 404",
                    "It runs when there is a network failure or the Promise rejects",
                    "It always runs after every fetch",
                    "It parses the response data",
                ],
                answer: "It runs when there is a network failure or the Promise rejects",
            },
            {
                id: "js-9-15",
                question: "What is an API?",
                options: [
                    "A type of database",
                    "An interface that allows different software applications to communicate",
                    "A JavaScript framework",
                    "A CSS library",
                ],
                answer: "An interface that allows different software applications to communicate",
            },
        ],
    },
    {
        module: "Day 10 – Final JavaScript Project Concepts",
        questions: [
            {
                id: "js-10-1",
                question: "What is localStorage used for?",
                options: [
                    "Storing data on the server",
                    "Storing key-value pairs in the browser that persist even after the page is closed",
                    "Storing temporary session data cleared when the tab closes",
                    "Sharing data between browser tabs",
                ],
                answer: "Storing key-value pairs in the browser that persist even after the page is closed",
            },
            {
                id: "js-10-2",
                question: "What does JSON.stringify() do in the context of localStorage?",
                options: [
                    "Reads a value from localStorage",
                    "Converts a JavaScript object to a string so it can be stored in localStorage",
                    "Deletes a key from localStorage",
                    "Validates the stored data",
                ],
                answer: "Converts a JavaScript object to a string so it can be stored in localStorage",
            },
            {
                id: "js-10-3",
                question: "What is the module system in modern JavaScript used for?",
                options: [
                    "Writing CSS styles",
                    "Splitting code into separate files using import and export",
                    "Running code in parallel",
                    "Managing the DOM",
                ],
                answer: "Splitting code into separate files using import and export",
            },
            {
                id: "js-10-4",
                question: "What does the export keyword do?",
                options: [
                    "Imports a module from a file",
                    "Makes a function, class, or variable available to import in other files",
                    "Executes a module",
                    "Declares a global variable",
                ],
                answer: "Makes a function, class, or variable available to import in other files",
            },
            {
                id: "js-10-5",
                question: "What is a JavaScript class?",
                options: [
                    "A CSS rule targeting an element",
                    "A template for creating objects with shared properties and methods",
                    "A type of loop",
                    "A function with no arguments",
                ],
                answer: "A template for creating objects with shared properties and methods",
            },
            {
                id: "js-10-6",
                question: "What does the constructor method do in a JavaScript class?",
                options: [
                    "Destroys the object",
                    "Runs when a new instance of the class is created to set up initial values",
                    "Defines class variables",
                    "Makes the class immutable",
                ],
                answer: "Runs when a new instance of the class is created to set up initial values",
            },
            {
                id: "js-10-7",
                question: "What does the new keyword do when used with a class?",
                options: [
                    "Deletes the existing object",
                    "Creates a new instance of the class",
                    "Resets the class to default state",
                    "Imports the class from another file",
                ],
                answer: "Creates a new instance of the class",
            },
            {
                id: "js-10-8",
                question: "What is inheritance in JavaScript classes?",
                options: [
                    "Sharing styles between HTML elements",
                    "A subclass extending a parent class to inherit its properties and methods",
                    "A function calling another function",
                    "Importing methods from a module",
                ],
                answer: "A subclass extending a parent class to inherit its properties and methods",
            },
            {
                id: "js-10-9",
                question: "What is a good way to handle errors in a JavaScript application?",
                options: [
                    "Ignore them and hope the user doesn't notice",
                    "Use try-catch blocks and display meaningful error messages",
                    "Refresh the page on any error",
                    "Log everything to localStorage",
                ],
                answer: "Use try-catch blocks and display meaningful error messages",
            },
            {
                id: "js-10-10",
                question: "What is debouncing in JavaScript?",
                options: [
                    "Removing bouncing animations",
                    "Delaying a function call until after a user stops performing an action",
                    "Batching multiple API calls",
                    "Compressing JavaScript files",
                ],
                answer: "Delaying a function call until after a user stops performing an action",
            },
            {
                id: "js-10-11",
                question: "Which tool would you use to bundle JavaScript files for production?",
                options: ["Babel", "Webpack or Vite", "npm", "localStorage"],
                answer: "Webpack or Vite",
            },
            {
                id: "js-10-12",
                question: "What does npm stand for?",
                options: [
                    "Node Package Module",
                    "Node Package Manager",
                    "New Project Manager",
                    "Node Program Method",
                ],
                answer: "Node Package Manager",
            },
            {
                id: "js-10-13",
                question: "What is the purpose of a .gitignore file?",
                options: [
                    "To ignore JavaScript errors",
                    "To list files and folders that should not be tracked by Git",
                    "To ignore CSS styles",
                    "To skip tests during a build",
                ],
                answer: "To list files and folders that should not be tracked by Git",
            },
            {
                id: "js-10-14",
                question: "What does linting do in a JavaScript project?",
                options: [
                    "Runs unit tests",
                    "Analyses code for potential errors and style issues",
                    "Compresses the JavaScript bundle",
                    "Generates documentation",
                ],
                answer: "Analyses code for potential errors and style issues",
            },
            {
                id: "js-10-15",
                question: "What is the best practice for variable naming in JavaScript?",
                options: [
                    "Use ALL_CAPS for all variables",
                    "Use camelCase for variables and functions",
                    "Use kebab-case for everything",
                    "Use single letters to save space",
                ],
                answer: "Use camelCase for variables and functions",
            },
        ],
    },
];
